import { render } from "./AdicionarOpcao.vue?vue&type=template&id=9cf73f46&ts=true"
import script from "./AdicionarOpcao.vue?vue&type=script&lang=ts"
export * from "./AdicionarOpcao.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__